import styled from 'styled-components';

import { basicBodyTextStyle, fonts, StyledFlex } from '@dreryk/react-components';

export const StyledSectionChip = styled(StyledFlex)`
   ${basicBodyTextStyle};
   padding: 6px 10px 4px;
   border: 2px solid ${(props) => props.theme.primary};
   border-radius: 20px;
   font-weight: ${fonts.fontWeightBold};
   color: ${(props) => props.theme.white};
   background-color: ${(props) => props.theme.primary};
   white-space: nowrap;
`;

StyledSectionChip.displayName = 'StyledSectionChip';
